import { render, staticRenderFns } from "./veStuLiteraryProgramAdmin.vue?vue&type=template&id=55a31a8a&scoped=true"
import script from "./veStuLiteraryProgramAdmin.vue?vue&type=script&lang=js"
export * from "./veStuLiteraryProgramAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a31a8a",
  null
  
)

export default component.exports